import React from 'react';
import { connect } from 'react-redux';

import LoginHeader from '../../components/auth/LoginHeader';
import ResetForm from '../../components/auth/ResetForm';

import './auth-page.scss';

const ForgotPasswordPage = () => {
  const onResetPassword = async () => {
  };

  return (
    <div className='login-page-container'>
      <LoginHeader />
      <div className='main-body'>
        <ResetForm onResetPassword={onResetPassword} />
      </div>
    </div>
  );
};

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = () => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);
